import { useTranslation } from '@centric-os/helpers';
import * as yup from 'yup';
import { SitesLocalePrefix } from '../../../enums';

export default () => {
  const { translate } = useTranslation();
  const LOCALE_PREFIX = SitesLocalePrefix.SITE_DROP_OFF;

  const schema = yup.object().shape({
    start_time: yup.date().nullable().required(translate('errorMessages.required')),
    end_time: yup.date().nullable().required(translate('errorMessages.required')),
    delivery_destinations: yup
      .array()
      .min(1, translate(`${LOCALE_PREFIX}.timeslots.minimumLocationSelect`)),
  });

  return {
    schema,
  };
};
